import { render, staticRenderFns } from "./demo-form.vue?vue&type=template&id=5683b81d&lang=html&"
import script from "./demo-form.vue?vue&type=script&lang=js&"
export * from "./demo-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports